import { API_CONSTANTS } from 'app/constants/api-contants';
import * as dataAccess from 'app/utils/ajax';

export const sendOtpApi = async (data) => {
  let payload = {
    data: data,
  };
  let responseObj = await dataAccess.post(API_CONSTANTS.GET_OTP, payload);
  return responseObj;
};

export const sendOtpVerify = async (data) => {
  let payload = {
    data: data,
  };
  let responseObj = await dataAccess.put(API_CONSTANTS.VERIFY_OTP, payload);
  return responseObj;
};

export const resendOtp = async (data) => {
  let payload = {
    data: data,
  };
  let responseObj = await dataAccess.post(API_CONSTANTS.RESEND_OTP, payload);
  return responseObj;
};

export const logoutAction = async () => {
  let responseObj = await dataAccess.get(API_CONSTANTS.LOGOUT);
  return responseObj;
};

export const getModulesPermissionAsPerUser = async () => {
  let responseObj =
    await dataAccess.get(`${API_CONSTANTS.GET_USER}/permission-list
`);
  return responseObj;
};

export const getMallPermissionAsPerUser = async () => {
  let responseObj =
    await dataAccess.get(`${API_CONSTANTS.GET_USER}/mall-permission
`);
  return responseObj;
};
